"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpScheduleCalendar = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const consts_1 = require("@opsbase/lib-time/consts");
const shiftTZLocalToUTC_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZLocalToUTC"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const AddIcon_1 = __importDefault(require("@opsbase/web-icons/icons/AddIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const SidePane_1 = __importDefault(require("@opsbase/web-ui/SidePane"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const OpScheduleCreateDialog_1 = __importDefault(require("../dialogs/OpScheduleCreateDialog"));
const OpScheduleDeleteDialog_1 = __importDefault(require("../dialogs/OpScheduleDeleteDialog"));
const OpScheduleEditDialog_1 = __importDefault(require("../dialogs/OpScheduleEditDialog"));
const OpScheduleCalendarController_1 = __importDefault(require("../OpScheduleCalendarController/OpScheduleCalendarController"));
const useOpScheduleCalendar_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendar"));
const useOpScheduleCalendarSelection_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendarSelection"));
const Calendar_1 = __importDefault(require("./Calendar"));
const CalendarDatePicker_1 = __importDefault(require("./CalendarDatePicker"));
const CalendarPlacePicker_1 = __importDefault(require("./CalendarPlacePicker"));
const CalendarScheduleList_1 = __importDefault(require("./CalendarScheduleList"));
const CalendarViewTypePicker_1 = __importDefault(require("./CalendarViewTypePicker"));
const OpScheduleOverview_1 = __importDefault(require("./OpScheduleOverview"));
const makeMyClasses = () => {
    return {
        root: {
            overflow: 'hidden',
            background: lib_palette_1.default.White.main,
        },
        bigButton: {
            minWidth: 200,
        },
        dots: {
            position: 'absolute',
            top: 100,
            left: '50%',
            zIndex: 1000,
        },
    };
};
const OpScheduleCalendar = function (props) {
    return (react_1.default.createElement(OpScheduleCalendarController_1.default, Object.assign({}, props),
        react_1.default.createElement(OpScheduleCalendarInner, { onChange: props.onChange, editable: props.editable })));
};
exports.OpScheduleCalendar = OpScheduleCalendar;
function OpScheduleCalendarInner(props) {
    const { onChange, editable } = props;
    const { loading, opDefinition } = (0, useOpScheduleCalendar_1.default)();
    const { selectedSchedule } = (0, useOpScheduleCalendarSelection_1.default)();
    const [createOptions, setCreateOptions] = (0, react_1.useState)({});
    const [showDialog, setShowDialog] = (0, react_1.useState)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const isEditable = editable;
    const _doStartCreation = (0, react_1.useMemo)(() => (options) => {
        setCreateOptions(options);
        setShowDialog('create');
    }, []);
    const handleClickEdit = (0, react_1.useCallback)(() => setShowDialog('edit'), []);
    const handleClickDelete = (0, react_1.useCallback)(() => setShowDialog('delete'), []);
    const handleCloseDialog = (0, react_1.useCallback)(() => setShowDialog(undefined), []);
    const handleClickAdd = (0, react_1.useCallback)(() => _doStartCreation({
        dueDate: (0, moment_timezone_1.default)().endOf('hour'),
    }), [_doStartCreation]);
    const handleAddNew = (0, react_1.useCallback)(({ start, end }) => {
        let dueDate, whenCanStart, whenCanView;
        if (start.isSame(end)) {
            dueDate = (0, shiftTZLocalToUTC_1.default)(end.clone().hours(8).minutes(0));
            whenCanStart = consts_1.DEFAULT_WHENCANSTART;
            whenCanView = consts_1.DEFAULT_WHENCANVIEW;
        }
        else {
            dueDate = end;
            whenCanStart = end.diff(start, 'minutes');
            whenCanView = whenCanStart + consts_1.HOUR_MINS * 5;
        }
        return _doStartCreation({ dueDate, whenCanStart, whenCanView });
    }, [_doStartCreation]);
    // silly problem with browsers on windoze.. adding a div with inline styles
    // otherwise the Horiz does not take full height.
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Horizontal_1.default, { stretch: true, classes: { root: myCss.root } },
            react_1.default.createElement(SidePane_1.default, { label: lib_i18n_1.default.t('navigation'), width: 360, left: true, startOpen: true, renderOpen: () => (react_1.default.createElement(Vertical_1.default, { gutter: true, padding: true },
                    react_1.default.createElement(Pane_1.default, null,
                        react_1.default.createElement(CalendarViewTypePicker_1.default, null)),
                    react_1.default.createElement(Pane_1.default, { grow: true, style: { position: 'relative' } },
                        react_1.default.createElement(Vertical_1.default, { gutter: true },
                            react_1.default.createElement(Pane_1.default, null,
                                react_1.default.createElement(CalendarPlacePicker_1.default, null)),
                            react_1.default.createElement(Pane_1.default, { grow: true },
                                react_1.default.createElement(CalendarDatePicker_1.default, null),
                                react_1.default.createElement(OpScheduleOverview_1.default, { isEditable: isEditable, onEdit: handleClickEdit, onDelete: handleClickDelete }),
                                ' '))),
                    react_1.default.createElement(Pane_1.default, { center: true },
                        react_1.default.createElement(Button_1.default, { fullWidth: true, noEvents: loading, classes: { root: myCss.bigButton }, icon: react_1.default.createElement(AddIcon_1.default, null), color: lib_palette_1.default.primary, disabled: !isEditable, label: lib_i18n_1.default.t('add-schedule'), onClick: handleClickAdd })))) }),
            react_1.default.createElement(Pane_1.default, { grow: true },
                !!loading && react_1.default.createElement(Dots_1.default, { className: myCss.dots, color: lib_palette_1.default.primary }),
                react_1.default.createElement(Calendar_1.default, { isEditable: isEditable, onAddEvent: handleAddNew })),
            react_1.default.createElement(SidePane_1.default, { label: lib_i18n_1.default.t('schedule-list'), width: 300, startOpen: false, renderOpen: () => (react_1.default.createElement(Vertical_1.default, { gutter: true, padding: true },
                    react_1.default.createElement(CalendarScheduleList_1.default, null))) })),
        showDialog === 'edit' && (react_1.default.createElement(OpScheduleEditDialog_1.default, { opSchedule: selectedSchedule, open: true, onChange: onChange, onClose: handleCloseDialog })),
        showDialog === 'create' && (react_1.default.createElement(OpScheduleCreateDialog_1.default, { opDefinition: opDefinition, initialOptions: createOptions, open: true, onChange: onChange, onClose: handleCloseDialog })),
        showDialog === 'delete' && (react_1.default.createElement(OpScheduleDeleteDialog_1.default, { id: selectedSchedule === null || selectedSchedule === void 0 ? void 0 : selectedSchedule.id, open: true, onChange: onChange, onClose: handleCloseDialog }))));
}
exports.default = exports.OpScheduleCalendar;
